import { ENDPOINT_ROOT, ENDPOINT_WORKSITES } from '@/common/constants';
import axiosAuth from '@/common/interceptors/axios.AuthInterceptor';

const deleteWorksite = (code) =>
  axiosAuth
    .delete(`${ENDPOINT_ROOT}/${ENDPOINT_WORKSITES}/${code}`)
    .then((res) => res.data);

export default deleteWorksite;
